import { SMARTSEND_API } from '~/lib/constants';

export function getPath(profile: string, path: string) {
  // return `https://smartsend-edge.serverless.p2g.systems/${profile}${path}`;
  // return `https://smartsend-edge.test.p2g.ninja/${profile}${path}`;
  // return `https://localhost:5001/${profile}${path}`;
  return `${SMARTSEND_API}/${profile}${path}`;
}
